.item {
    color: var(--ironside);
    font-size: 16px;
    text-decoration: none;

    &:hover,
    &:focus,
    &[data-state="open"] {
        color: var(--blue);
    }
}

.subMenu {
    background-color: var(--white);
    border-radius: 6px;
    box-shadow:
        0 0 6px 0 rgb(var(--ironside-base) / 40%),
        0 0 6px 0 rgb(var(--ironside-base) / 40%);
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    min-width: 160px;
    z-index: 99;
}

.subItem {
    composes: item;
    border-bottom: 1px solid rgb(var(--ironside-base) / 50%);
    padding: 16px;
}

.mobileItem {
    composes: item;
    border-bottom: 1px solid rgb(var(--ironside-base) / 50%);
    font-weight: bold;
    padding: 33px 0;
}
